import { render, staticRenderFns } from "./CompleteStat.vue?vue&type=template&id=0dc18f2c&scoped=true&"
import script from "./CompleteStat.vue?vue&type=script&lang=js&"
export * from "./CompleteStat.vue?vue&type=script&lang=js&"
import style0 from "./CompleteStat.vue?vue&type=style&index=0&id=0dc18f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc18f2c",
  null
  
)

export default component.exports